export default __webpack_public_path__ + "static/media/2627 knife block A side.c552a0b8.png";